import ReceberModel from "@/models/receber.model";

class ReceberResponse {

    itens: Array<ReceberModel> | [];
    total_parcela: string | null;
    total_recebido: string | null;
    total_aberto: string | null;

    constructor() {
        this.itens = [];
        this.total_parcela = null;
        this.total_recebido = null;
        this.total_aberto = null;
    }

}

export default ReceberResponse;
